angular.module('impactx.search').service("SearchSuggestions", SearchSuggestions);
SearchSuggestions.$inject = ['dataGen', '$context', '$q', 'AppConfiguration'];


function SearchSuggestions(dataGen, $context, $q, AppConfiguration) {
    var terms = [];
    var searchHistory = [];
    var classifications = [];
    var suppliers = [];
    var lots = [];

    function refreshTerms(searchText) {
        if (AppConfiguration.get('showTermSuggestions')) {
            if (searchText.length > 2) {
                var result = {};
                return dataGen.getData(result, {query: searchText}, "/suggest/term", null, true).then(function () {
                    terms = [];
                    angular.forEach(result.data.suggests, function (suggestEntry) {
                        suggestEntry.isTerm = true;
                        terms.push(suggestEntry);
                    });
                    return terms;
                });
            }
        }
        return $q.when(terms);
    }

    function refreshSearchHistory(searchText) {
        searchHistory = [];
        var result = {};
        return dataGen.getData(result, {query: searchText}, "/suggest/history", null, true).then(function () {
            searchHistory = [];
            angular.forEach(result.data.suggests, function (suggestEntry) {
                suggestEntry.isSearchHistory = true;
                searchHistory.push(suggestEntry);
            });
            return searchHistory;
        });
    }

    function refreshClassifications(searchText) {
        if ($context.isClassificationSuggestActivated.value && searchText.length > 2) {
            var result = {};
            return dataGen.getData(result, {query: searchText}, "/suggest/eclass", null, true).then(function () {
                classifications = [];
                angular.forEach(result.data.suggests, function (suggestEntry) {
                    suggestEntry.isClassification = true;
                    classifications.push(suggestEntry);
                });

                return classifications;
            });
        }
        return $q.when(classifications);
    }

    function refreshSuppliers(searchText, local) {
        if (local) {
            suppliers = [];
        }
        else {
            if (searchText.length > 2) {
                var result = {};
                return dataGen.getData(result, {query: searchText}, "/suggest/supplier", null, true).then(function () {
                    suppliers = [];
                    angular.forEach(result.data.suggests, function (suggestEntry) {
                        suggestEntry.isSupplier = true;
                        suppliers.push(suggestEntry);
                    });

                    return suppliers;
                });
            }
        }
        return $q.when(suppliers);
    }

    function refreshLots(searchText, local) {
        if (local) {
            lots = [];
        }
        else {
            if (AppConfiguration.get('showLotSuggestions')) {
                if (searchText.length > 2) {
                    var result = {};
                    return dataGen.getData(result, {query: searchText}, "/suggest/lot", null, true).then(function () {
                        lots = [];
                        angular.forEach(result.data.suggests, function (suggestEntry) {
                            suggestEntry.isLot = true;
                            lots.push(suggestEntry);
                        });

                        return lots;
                    });
                }
            }
        }
        return $q.when(lots);
    }

    function getSuggestions(searchText, local) {
        return $q.all([refreshTerms(searchText), refreshSearchHistory(searchText), refreshClassifications(searchText), refreshSuppliers(searchText, local), refreshLots(searchText, local)])
            .then(function (result) {
                var termEntries = result[0];
                var historyEntries = result[1];
                var classificationEntries = result[2];
                var supplierEntries = result[3];
                var lotEntries = result[4]

                return termEntries.concat(classificationEntries, historyEntries, supplierEntries, lotEntries);
            });
    }

    return {
        getSuggestions: getSuggestions
    };
}